import React, { useState } from "react";
import Swal from 'sweetalert2';

const ImageUpload = ({ onFileSelect, accept, maxSize }) => {
  const [fileName, setFileName] = useState('');
  const [preview, setPreview] = useState(null);

  const handleFileChange = (event) => {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      
      // Convertir accept a array si es una cadena
      const acceptedTypes = typeof accept === 'string' 
        ? accept.split(',').map(item => item.trim())
        : accept;
      
      // Validar tipo de archivo
      if (!acceptedTypes.includes(file.type)) {
        Swal.fire({
          icon: 'error',
          title: 'Formato no válido',
          text: 'Por favor, sube solo imágenes válidas',
        });
        event.target.value = '';
        setFileName('');
        setPreview(null);
        return;
      }
      
      // Validar tamaño
      if (file.size > maxSize * 1024 * 1024) {
        Swal.fire({
          icon: 'error',
          title: 'Archivo demasiado grande',
          text: `El tamaño máximo permitido es ${maxSize}MB`,
        });
        event.target.value = '';
        setFileName('');
        setPreview(null);
        return;
      }
      
      // Crear vista previa
      const reader = new FileReader();
      reader.onload = (e) => setPreview(e.target.result);
      reader.readAsDataURL(file);
      
      setFileName(file.name);
      onFileSelect(file);
    }
  };

  return (
    <div className="image-upload">
      <input 
        type="file" 
        accept={typeof accept === 'string' ? accept : accept.join(', ')} 
        onChange={handleFileChange} 
      />
      {preview && (
        <div className="mt-3">
          <img 
            src={preview} 
            alt="Vista previa" 
            style={{ maxWidth: '200px', maxHeight: '200px' }} 
          />
        </div>
      )}
      {fileName && <p className="mt-2">Archivo seleccionado: {fileName}</p>}
    </div>
  );
};

export default ImageUpload;